import keyBy from 'lodash/keyBy';
import mapValues from 'lodash/mapValues';

import { PrinterType } from '@/modules/common/types';
import { GcrFileItem } from '@/modules/gcrs/types';
import { Model } from '@/modules/models/types';

import { EventPrinter } from '../types';

export const getModelGcrFileDetails = ({
  modelId,
  models,
  gcrs,
  sizeId,
  printers,
  eventPrinters,
}: {
  sizeId: string;
  modelId: string;
  models: Model[];
  gcrs: GcrFileItem[];
  printers: PrinterType[];
  eventPrinters: EventPrinter[];
}): {
  typeId?: string;
  emptyGcrFilePrinter: PrinterType | null;
} => {
  const formattedPrintersData = mapValues(keyBy(printers, 'id'));

  const activeModel = models.find((model) => model.id === modelId);

  if (!activeModel) {
    return {
      typeId: undefined,
      emptyGcrFilePrinter: null,
    };
  }

  const filteredGcrFilePrinters = gcrs
    .filter(
      ({ type, size }) => type.id === activeModel.type.id && size.id === sizeId
    )
    .map((item) => item.printer);
  const eventPrinterIds = filteredGcrFilePrinters.map((item) => item.id);
  const emptyGcrFilePrinter = eventPrinters.find(
    (printer) => !eventPrinterIds.includes(printer.printerId)
  );

  return {
    typeId: activeModel.type?.id,
    emptyGcrFilePrinter: emptyGcrFilePrinter
      ? formattedPrintersData[emptyGcrFilePrinter?.printerId]
      : null,
  };
};
